import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/pro-solid-svg-icons';

import ClickableIcon from 'components/clickable_icon';

export default class DropdownControl extends React.Component {
  render() {
    let { icon } = this.props;
    if (icon !== false) {
      if (!icon || icon === true) {
        icon = faSortDown;
      }
    }

    let content;
    if (this.props.label) {
      // With a label, the overall click target is OK
      content = <React.Fragment>
        {icon && <FontAwesomeIcon icon={icon} size={this.props.size} />} {this.props.label}
      </React.Fragment>;
    } else if (icon) {
      // Without a label, just the icon alone is too small of a click target
      content = <ClickableIcon icon={icon} size={this.props.size} />;
    }

    return (
      <span className="clickable" onClick={this.props.onClick}>
        {content}
      </span>
    );
  }
}

DropdownControl.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  label: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func, // Injected by react-bootstrap
};
